import { AnimationEvent } from '@angular/animations';
import { Directionality } from '@angular/cdk/bidi';
import { AfterViewInit, Directive, EventEmitter, Output } from '@angular/core';
import { TieredMenu } from 'primeng/tieredmenu';

@Directive({
   
  selector: 'p-tieredMenu',
  standalone: true,
})
export class TieredMenuPositionDirective implements AfterViewInit {
  // Since tiered menue doesn't have onShow/onHide like p-menu, we will add them to it
  @Output() onShow = new EventEmitter<any>();
  @Output() onHide = new EventEmitter<any>();

  constructor(
    private tieredMenu: TieredMenu,
    public dir: Directionality,
  ) {}

  ngAfterViewInit(): void {
    // preserve reference to the old animation start callback
    const onOverlayAnimationStart =
      this.tieredMenu.onOverlayAnimationStart.bind(this.tieredMenu);
    this.tieredMenu.onOverlayAnimationStart = (event: AnimationEvent): void => {
      onOverlayAnimationStart(event);
      if (event.toState === 'visible') {
        this._fixMenuPosition();
        this.onShow.emit(this.tieredMenu);
      }
      if (event.toState === 'void') {
        this.onHide.emit(this.tieredMenu);
      }
    };
  }

  private _fixMenuPosition(): void {
    if (this.tieredMenu?.el?.nativeElement) {
      // @ToDo since we append the menu to the body there is no connection between the root component and the appended menu
      // except the class ng-nts-num, we need to optimize it later to find better approach
      const menuEl = this.tieredMenu?.el?.nativeElement as HTMLElement;
      const componentToken = Array.from(
        this.tieredMenu.el.nativeElement.classList,
      ).filter((cls) => cls.toString().indexOf('ng-tns') > -1)[0];
      const subMenus = document.querySelectorAll(
        '.' + componentToken + ' p-tieredmenusub .p-submenu-list',
      ) as unknown as HTMLElement[];

      if (componentToken) {
        const menuRect = menuEl.getBoundingClientRect();
        if (this.dir.value === 'ltr') {
          const { width, left } = menuRect;
          const menuRight = left + width + 170;
          if (
            menuRight >= window.innerWidth &&
            window.innerWidth >= 768 &&
            !!subMenus.length
          ) {
            subMenus.forEach((subMenu) => {
              subMenu.style.left = `auto`;
              subMenu.style.right = `100%`;
            });
          }
          if (left <= 0) {
            subMenus.forEach((subMenu) => {
              subMenu.style.left = `100%`;
              subMenu.style.right = `auto`;
            });
          }
        } else {
          const { width, right } = menuRect;
          const menuleft = right + width + 170;
          if (
            menuleft <= window.innerWidth &&
            window.innerWidth >= 768 &&
            !!subMenus.length
          ) {
            subMenus.forEach((subMenu) => {
              subMenu.style.right = `auto`;
              subMenu.style.left = `100%`;
            });
          }
          if (right <= 0) {
            subMenus.forEach((subMenu) => {
              subMenu.style.right = `100%`;
              subMenu.style.left = `auto`;
            });
          }
        }
      }
    }
  }
}
